import { FleetType, memoize } from '@jucy-ui/common';

export const getLeadTimeHours = memoize(({ fleetType }: { fleetType?: FleetType }) => fleetType?.leadTimeHours || 0.5);
